/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   preload component
 */

import { matchRoutesByName } from '@zcode/router-utils'
import QuickLRU from 'quick-lru'

import { routeComponents } from './index'

const flattenRoutes = Object.keys(routeComponents).map((name) => {
  return {
    name,
    ...routeComponents[name],
  }
})

// hash to keep track of loaded status for each component
const loaded = new QuickLRU({ maxSize: 100 })
const preload = (componentNames) => {
  const preloadComponents = matchRoutesByName(flattenRoutes, componentNames)
  const filtered = preloadComponents.filter(({ name }) => !loaded.get(name))

  filtered.forEach(({ component, name }) => {
    try {
      component && typeof component.preload === 'function' && component.preload()
      loaded.set(name, true)
    } catch (e) {
      loaded.set(name, false)
    }
  })
}

export default preload
